/**
 * V0 カードボタンイベントハンドラー
 * いいね・リンクコピー・カート追加機能
 */

(function() {
  'use strict';

  // いいね機能
  class LikeManager {
    constructor() {
      this.storageKey = 'v0_liked_products';
      this.storageKeyV2 = 'v0_liked_products_v2';
      this.userLikes = this.loadUserLikes();
    }

    loadUserLikes() {
      try {
        // V2フォーマット（商品情報を含む）を優先
        const storedV2 = localStorage.getItem(this.storageKeyV2);
        if (storedV2) {
          return JSON.parse(storedV2);
        }

        // V1フォーマット（IDのみ）からの移行
        const storedV1 = localStorage.getItem(this.storageKey);
        if (storedV1) {
          const ids = JSON.parse(storedV1);
          // IDのみの配列を新形式に変換
          return ids.map(id => ({ id: id.toString() }));
        }

        return [];
      } catch(e) {
        console.error('Failed to load likes:', e);
        return [];
      }
    }

    saveUserLikes() {
      try {
        localStorage.setItem(this.storageKeyV2, JSON.stringify(this.userLikes));
        // 後方互換性のためV1も保存
        const ids = this.userLikes.map(item => item.id);
        localStorage.setItem(this.storageKey, JSON.stringify(ids));
      } catch(e) {
        console.error('Failed to save likes:', e);
      }
    }

    isLiked(productId) {
      return this.userLikes.some(item => item.id === productId.toString());
    }

    toggleLike(productId, productInfo = {}) {
      const id = productId.toString();
      if (this.isLiked(id)) {
        this.userLikes = this.userLikes.filter(item => item.id !== id);
      } else {
        // 商品情報を含めて保存（モーダル・カテゴリ・尺表示に必要な情報も追加）
        this.userLikes.push({
          id: id,
          handle: productInfo.handle || '',
          title: productInfo.title || '',
          image: productInfo.image || '',
          price: productInfo.price || '',
          variantId: productInfo.variantId || '',
          category: productInfo.category || '',
          duration: productInfo.duration || '',
          preview: productInfo.preview || '',
          description: productInfo.description || '',
          tags: productInfo.tags || '',
          resolution: productInfo.resolution || '',
          aiGenerated: productInfo.aiGenerated || false,
          aiTool: productInfo.aiTool || '',
          width: productInfo.width || '',
          height: productInfo.height || '',
          fps: productInfo.fps || '',
          fileSize: productInfo.fileSize || '',
          fileSizeDisplay: productInfo.fileSizeDisplay || '',
          aspectRatio: productInfo.aspectRatio || ''
        });
      }
      this.saveUserLikes();
      return this.isLiked(id);
    }

    updateUI(productId) {
      const cards = document.querySelectorAll(`.v0-card[data-product-id="${productId}"]`);
      const isLiked = this.isLiked(productId);

      cards.forEach(card => {
        const likeBtn = card.querySelector('[data-action="like"]');
        if (likeBtn) {
          const icon = likeBtn.querySelector('svg');
          if (isLiked) {
            if (icon) {
              icon.setAttribute('fill', '#ef4444');
              icon.style.color = '#ef4444';
            }
            likeBtn.classList.add('v0-card__btn--liked');
          } else {
            if (icon) {
              icon.setAttribute('fill', 'none');
              icon.style.color = '';
            }
            likeBtn.classList.remove('v0-card__btn--liked');

            // お気に入りページの場合、カードを非表示にする
            const currentPath = window.location.pathname;
            if (currentPath.includes('/pages/favorites') || currentPath.includes('/pages/liked')) {
              card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
              card.style.opacity = '0';
              card.style.transform = 'scale(0.9)';
              setTimeout(() => {
                card.style.display = 'none';
              }, 300);
            }
          }
        }
      });
    }

    init() {
      const cards = document.querySelectorAll('.v0-card[data-product-id]');
      cards.forEach(card => {
        const productId = card.dataset.productId;
        if (this.isLiked(productId)) {
          this.updateUI(productId);
        }
      });
    }
  }

  window.likeManager = new LikeManager();

  // リンクコピー機能
  function copyShareLink(productHandle, event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const url = `${window.location.origin}/products/${productHandle}`;

    // クリップボードにコピー
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        showToast('リンクをコピーしました');
      }).catch(err => {
        console.error('Failed to copy:', err);
        fallbackCopy(url);
      });
    } else {
      fallbackCopy(url);
    }

    // ボタンアニメーション
    const button = event?.target.closest('button');
    if (button) {
      button.style.transform = 'scale(1.2)';
      setTimeout(() => {
        button.style.transform = 'scale(1)';
      }, 200);
    }
  }

  // フォールバックコピー方法（古いブラウザ対応）
  function fallbackCopy(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      showToast('リンクをコピーしました');
    } catch (err) {
      console.error('Fallback copy failed:', err);
      showToast('コピーに失敗しました');
    }

    document.body.removeChild(textArea);
  }

  // トースト通知表示
  function showToast(message) {
    // 既存のトーストを削除
    const existingToast = document.querySelector('.v0-toast');
    if (existingToast) {
      existingToast.remove();
    }

    const toast = document.createElement('div');
    toast.className = 'v0-toast';
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      top: 80px;
      right: 24px;
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 14px;
      z-index: 10000;
      animation: v0-toast-slide-in 0.3s ease-out;
    `;

    document.body.appendChild(toast);

    // フェードアウトして削除
    setTimeout(() => {
      toast.style.animation = 'v0-toast-fade-out 0.3s ease-in forwards';
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, 2000);
  }

  // カート追加機能
  function addToCart(variantId, productTitle, event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const button = event?.target.closest('button');
    if (button) {
      button.disabled = true;
      button.style.opacity = '0.5';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      showToast('カートに追加しました');

      // カート数更新
      if (window.updateCartCount) {
        window.updateCartCount();
      }

      // ボタンアニメーション
      if (button) {
        button.classList.add('v0-card__btn--active');
        setTimeout(() => {
          button.classList.remove('v0-card__btn--active');
        }, 1000);
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showToast('カート追加に失敗しました');
    })
    .finally(() => {
      if (button) {
        button.disabled = false;
        button.style.opacity = '1';
      }
    });
  }

  // イベントハンドラー設定（重複防止のため、1回のみ実行フラグを使用）
  function setupButtonHandlers() {
    const cards = document.querySelectorAll('.v0-card');

    cards.forEach(card => {
      // 既に初期化済みの場合はスキップ
      if (card.dataset.buttonsInitialized === 'true') {
        return;
      }

      const productId = card.dataset.productId;
      const productHandle = card.dataset.productHandle;


      // いいねボタン
      const likeBtn = card.querySelector('[data-action="like"]');
      if (likeBtn && !likeBtn.dataset.listenerAttached) {
        likeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();


          // 商品情報を収集（モーダル・カテゴリ・尺表示に必要な情報も含む）
          const productInfo = {
            handle: card.dataset.productHandle || '',
            title: card.dataset.title || card.querySelector('.v0-card__title')?.textContent || '',
            image: card.querySelector('.v0-card__thumbnail')?.src || card.querySelector('img')?.src || '',
            price: card.dataset.price || card.querySelector('.v0-card__price')?.textContent || '',
            variantId: card.querySelector('[data-variant-id]')?.dataset.variantId || card.dataset.variantId || '',
            category: card.dataset.category || '',
            duration: card.dataset.duration || '',
            preview: card.dataset.preview || '',
            description: card.dataset.description || '',
            tags: card.dataset.tags || '',
            resolution: card.dataset.resolution || '',
            aiGenerated: card.dataset.aiGenerated || false,
            aiTool: card.dataset.aiTool || '',
            width: card.dataset.width || '',
            height: card.dataset.height || '',
            fps: card.dataset.fps || '',
            fileSize: card.dataset.fileSize || '',
            fileSizeDisplay: card.dataset.fileSizeDisplay || '',
            aspectRatio: card.dataset.aspectRatio || ''
          };


          const isLiked = window.likeManager.toggleLike(productId, productInfo);

          window.likeManager.updateUI(productId);

          // アニメーション
          likeBtn.style.transform = 'scale(1.2)';
          setTimeout(() => {
            likeBtn.style.transform = 'scale(1)';
          }, 200);

          showToast(isLiked ? 'お気に入りに追加しました' : 'お気に入りから削除しました');
        });
        likeBtn.dataset.listenerAttached = 'true';
      }

      // リンクコピーボタン
      const shareBtn = card.querySelector('[data-action="share"]');
      if (shareBtn && productHandle && !shareBtn.dataset.listenerAttached) {
        shareBtn.addEventListener('click', (e) => {
          copyShareLink(productHandle, e);
        });
        shareBtn.dataset.listenerAttached = 'true';
      }

      // カート追加ボタン
      const cartBtn = card.querySelector('[data-action="cart"]');
      if (cartBtn && !cartBtn.dataset.listenerAttached) {
        const variantId = cartBtn.dataset.variantId;
        const productTitle = cartBtn.dataset.productTitle || card.dataset.title;
        if (variantId) {
          cartBtn.addEventListener('click', (e) => {
            addToCart(variantId, productTitle, e);
          });
          cartBtn.dataset.listenerAttached = 'true';
        }
      }

      // カードを初期化済みとしてマーク
      card.dataset.buttonsInitialized = 'true';
    });
  }

  // CSSアニメーション追加
  if (!document.getElementById('v0-card-buttons-styles')) {
    const style = document.createElement('style');
    style.id = 'v0-card-buttons-styles';
    style.textContent = `
      @keyframes v0-toast-slide-in {
        0% { opacity: 0; transform: translateX(100px); }
        100% { opacity: 1; transform: translateX(0); }
      }

      @keyframes v0-toast-fade-out {
        0% { opacity: 1; transform: translateX(0); }
        100% { opacity: 0; transform: translateX(100px); }
      }

      .v0-card__btn--active {
        background-color: rgba(34, 197, 94, 0.2) !important;
      }

      .v0-card__btn--liked svg {
        fill: #ef4444 !important;
        color: #ef4444 !important;
      }

      .v0-card__btn {
        transition: all 0.2s ease;
      }

      .v0-card__btn:active {
        transform: scale(0.95);
      }
    `;
    document.head.appendChild(style);
  }

  // 初期化（即座に実行 + DOMContentLoaded）
  function initialize() {
    window.likeManager.init();
    setupButtonHandlers();
  }

  // ページ読み込み時に即座に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    // DOMがすでに読み込まれている場合は即座に実行
    initialize();
  }

  // 念のため、少し遅延して再度実行（ホバー時のボタン表示に対応）
  setTimeout(initialize, 100);

  // ページ遷移後の再初期化（SPAサポート）
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      setTimeout(() => {
        window.likeManager.init();
        setupButtonHandlers();
      }, 500);
    }
  }).observe(document, { subtree: true, childList: true });

  // 動的コンテンツ対応（検索フィルター等）
  window.reinitializeCardButtons = function() {
    setupButtonHandlers();
  };

  // グローバル関数として公開
  window.copyShareLink = copyShareLink;
  window.addToCart = addToCart;
  window.showToast = showToast;

})();
